import {Component} from 'react';
import { doubleToStringMonthly } from '../../../objects/CommonUse/double_functions';

class SavingsGeneralDisplay extends Component {
        constructor(props) {
             super(props);
        }
             
render() {        
    this.transferFeeClass = "";
    if (this.props.summaryData.totalTransferFee > 0){
        this.transferFeeClass = "text-warning font-weight-bold"
    }
return <>     
    <div className="container">      
        <div className="row">
            <div className="col-sm-4 text-left">
                <span className="font-weight-bold">Current Cash: </span>
                <span>{doubleToStringMonthly(this.props.summaryData.currentCash)}</span>
            </div>
           
            <div className="col-sm-4 text-left">
                <span className="font-weight-bold">Monthly Income: </span>
                <span>{doubleToStringMonthly(this.props.summaryData.monthlyIncome)}</span>
            </div>
            <div className="col-sm-4 text-left">
                <span className="font-weight-bold">Monthly Savings: </span>
                <span>{doubleToStringMonthly(this.props.summaryData.monthlySavingsAmt)}</span>
            </div>
        </div>
        {this.props.callingProcess === "detail"  ?
            <div className="row">
                <div className="col-sm-4 text-left">
                    <span className="font-weight-bold">Total Deposited: </span>
                    <span>{doubleToStringMonthly(this.props.summaryData.totalDeposited)}</span>
                </div>
                {this.props.savingsClass === "bank" ?
                    <div className="col-sm-4 text-left">
                        <span className="font-weight-bold">Interest Earned: </span>
                        <span>{doubleToStringMonthly(this.props.summaryData.totalInterestEarned)}</span>
                    </div>
                :
                    <div className="col-sm-4 text-left">
                        <span className="font-weight-bold">Company Match Amt: </span>
                        <span>{doubleToStringMonthly(this.props.summaryData.totalMatchAmt)}</span>
                    </div>
                }

                <div className="col-sm-4 text-left">
                    <span className="font-weight-bold">Total Savings: </span>
                    <span>{doubleToStringMonthly(this.props.summaryData.totalSavings)}</span>
                </div>
            </div>
        :
            null
        }

        {(this.props.step === "change" && this.props.fieldErrors === true) ||
            this.props.step === "confirm" ?
            <>
                <div className="row">
                    <div className="col-sm-4 text-left">
                        <span className="font-weight-bold">Total Transfer Amt: </span>
                        <span>{doubleToStringMonthly(this.props.summaryData.totalTransferAmt)}</span>
                    </div>
                    <div className="col-sm-4 text-left">
                        <span className="font-weight-bold">One-Time Amt: </span>
                        <span>{doubleToStringMonthly(this.props.summaryData.totalOneTimeAmt)}</span>
                    </div>
                    <div className="col-sm-4 text-left">
                        <span className="font-weight-bold">New Monthly Savings: </span>
                        <span>{doubleToStringMonthly(this.props.summaryData.newMonthlyAmt)}</span>
                    </div>
                </div>
                {this.props.summaryData.totalTransferFee > 0  ?
                    <div className="row">
                        <div className="col-sm-4 text-left">
                            <span className="font-weight-bold">Total Transfer Fee: </span>
                            <span>{doubleToStringMonthly(this.props.summaryData.totalTransferFee)}</span>
                        </div>
                        <div className="col-sm-4 text-left"></div>
                        <div className="col-sm-4 text-left"></div>
                    </div>
                :
                    null
                }
            </>
        :
            null
        }
       
        {(this.props.step === "change" && this.props.fieldErrors === true &&
        this.props.summaryData.totalTransferAmt > 0 )  ?
            <div className="row ">
                <div className={`col-sm-4 text-left ${this.transferFeeClass}`}>
                    <span className="font-weight-bold">Transfer Fee: </span>
                    <span>{doubleToStringMonthly(this.props.summaryData.totalTransferFee)}</span>
                </div>
            </div>
                          
        :
            null
        }
    </div>
    </>
}
}

export default SavingsGeneralDisplay;